import axios from 'axios'
import moment from 'moment'
import { dateToApiString } from '../../utils/dateTimeUtils'
import { getRestApiConfig } from '../config'
import { AxiosErrorResult } from '../errors'
import {
    StartProtectionDay,
    ArrivalTime,
    FreeServiseTimes,
    ApiStartProtectionDay,
} from './types'

export const getArrivalTime = async (
    lat: number,
    lng: number,
): Promise<ArrivalTime> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(
        `/api/v1/TimeTerms/ArrivalTime?lat=${lat.toFixed(6)}&lng=${lng.toFixed(
            6,
        )}`,
        restApiConfig.baseUrl,
    ).href
    const response = await axios.get<ArrivalTime>(endpointUrl, {
        headers: { ...restApiConfig.authHeader },
    })
    return response.data
}

export const getFreeServiseTimes = async (
    carID?: string,
    synonym?: string,
    date?: Date,
) => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `api/v1/TimeTerms/FreeServiseTimes?date=${
                date ? dateToApiString(date) : ''
            }&cardId=${carID}&synonym=${synonym}`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.get<FreeServiseTimes>(endpointUrl, {
            headers: { ...restApiConfig.authHeader },
        })
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const getStartProtectionDays = async (): Promise<
    StartProtectionDay[]
> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(
        `api/v1/TimeTerms/StartProtectionDays`,
        restApiConfig.baseUrl,
    ).href
    const response = await axios.get<ApiStartProtectionDay[]>(endpointUrl, {
        headers: { ...restApiConfig.authHeader },
    })
    return response.data.map((x) => {
        return {
            startDate: moment(x.startDate),
            endDate: moment(x.endDate),
            isAvailable: x.isAvailable,
        }
    })
}

export const getPublicHolidays = async (year: string): Promise<string[]> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(
        `api/v1/TimeTerms/PublicHolidays?year=${year}`,
        restApiConfig.baseUrl,
    ).href
    const response = await axios.get<string[]>(endpointUrl, {
        headers: { ...restApiConfig.authHeader },
    })
    return response.data
}
